
export default {
  data() {
    return {
      position: "bottom-right",
    };
  },
};
